<template>
  <div class="option-product-caption">
    <div class="row">
      <div class="col-xs-12">
        <label
          class="option-product-caption__label"
          for="patch-caption"
        >
          <span class="option-product-caption__required-symbol">*</span>
          {{ optionProductCaption.CaptionLabel }}
        </label>
        <div class="input-group option-product-caption__input-group">
          <caption-input-default
            v-if="!optionProductCaption.InitialCaption && !optionProductCaptionHasChoices"
            :option-product-caption="optionProductCaption"
            :option-product="optionProduct"
          />
          <caption-input-initials
            v-if="optionProductCaption.InitialCaption && !optionProductCaptionHasChoices"
            :option-product-caption="optionProductCaption"
            :option-product="optionProduct"
          />
          <caption-input-select
            v-if="optionProductCaptionHasChoices"
            :option-product-caption="optionProductCaption"
            :option-product="optionProduct"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CaptionInputDefault from './CaptionInputs/DefaultInput'
import CaptionInputInitials from './CaptionInputs/InitialsInput'
import CaptionInputSelect from './CaptionInputs/SelectInput'

export default {
  name: 'OptionProductCaption',
  components: {
    CaptionInputDefault,
    CaptionInputInitials,
    CaptionInputSelect
  },
  props: {
    optionProductCaption: { type: Object, default: null, required: true },
    optionProduct: { type: Object, default: null, required: true }
  },

  computed: {
    optionProductCaptionHasChoices () {
      return this.optionProductCaption.Choices != null && this.optionProductCaption.Choices.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.option-product-caption {
  &__input-group {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/OptionProduct/OptionProductCaption.vue